<template>
  <div class="flex justify-center min-h-screen bg-white pt-16">
    <div class="p-8 rounded-lg shadow-md max-w-md w-full text-center">
      <h1 class="text-4xl font-bold text-gray-800 mb-4">404</h1>
      <h2 class="text-2xl font-semibold text-gray-700 mb-4">Página não encontrada</h2>
      <p class="text-gray-600 mb-6">
        A página que você está procurando não existe ou foi movida.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    // Log para monitoramento (opcional)
    console.log('404 - Página não encontrada:', this.$route.path);
  }
}
</script>